import React from 'react'
import {ModeleTypeAction, modeleTypesActionsInitValues} from '../../../components/Models'
import {TypesActionsForm} from './components/TypesActionsForm'
import {useNavigate} from 'react-router-dom'
import {createTypesActions} from '../../../components/requests'
import Swal from 'sweetalert2'

const TypesActionsAddPage = () => {
  const navigate = useNavigate()

  const submitForm = async (fieldsToUpdate: Partial<ModeleTypeAction>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleTypesActionsInitValues}, fieldsToUpdate)
    try {
      const typeCLientRequest = await createTypesActions(updatedData)
      if (typeCLientRequest?.status === 200) {
        if (typeCLientRequest?.data?.id !== undefined && typeCLientRequest?.data?.id !== null) {
          navigate(`/types-actions/liste`)
        }
      }
    } catch (ex: any) {
      if (ex.response?.status === 400) {
        const errorMessage =
          ex.response?.data?.message || 'Ce type action avec ce code existe déjà.'
        Swal.fire({
          title: 'Oups',
          text: errorMessage,
          icon: 'warning',
          confirmButtonText: 'OK',
          confirmButtonColor: '#1BC5BD',
        })
      } else {
        console.error(ex)
      }
    } finally {
      callback()
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Créer un type action</h3>
          </div>
        </div>

        <div>
          <TypesActionsForm
            typeId={null}
            data={modeleTypesActionsInitValues}
            submitForm={submitForm}
          />
        </div>
      </div>
    </>
  )
}

export default TypesActionsAddPage
